'use client';
import { useRoomInfo } from '@liveblocks/react';
import React__default, { useMemo } from 'react';
import { classNames } from '../../utils/class-names.mjs';

function Room({ roomId, className, ...props }) {
  const { info, isLoading } = useRoomInfo(roomId);
  const resolvedRoomName = useMemo(() => {
    return info?.name ?? roomId;
  }, [info?.name, roomId]);
  return /* @__PURE__ */ React__default.createElement("span", {
    className: classNames("lb-name lb-room", className),
    "data-loading": isLoading ? "" : void 0,
    ...props
  }, isLoading ? null : resolvedRoomName);
}

export { Room };
//# sourceMappingURL=Room.mjs.map
